import { render, staticRenderFns } from "./Authenticated.vue?vue&type=template&id=67a4e6c2&scoped=true"
import script from "./Authenticated.vue?vue&type=script&lang=ts"
export * from "./Authenticated.vue?vue&type=script&lang=ts"
import style0 from "./Authenticated.vue?vue&type=style&index=0&id=67a4e6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a4e6c2",
  null
  
)

export default component.exports